(function() {
  // Global delegated click handler for accordion toggle - guarantees opening/closing regardless of init timing
  document.addEventListener('click', function(event) {
    var toggleEl = event.target.closest('.artisan-summary') || event.target.closest('[id^="artisan-toggle-"]');
    if (!toggleEl) return;

    var addon = toggleEl.closest('.artisan-addon');
    if (!addon) return;

    addon.classList.toggle('is-open');

    if (addon.classList.contains('is-open')) {
      var checkbox = addon.querySelector('.artisan-check');
      var textInput = addon.querySelector('.artisan-text-input');
      if (checkbox) {
        window.setTimeout(function() {
          if (checkbox.checked && textInput) {
            textInput.focus();
          } else {
            checkbox.focus();
          }
        }, 150);
      }
    }
  });

  function initPersonalization() {
    /* Guard: prevent double initialization on a single page load.
       This protects against any residual duplicate DOM or re-fired events.
       The guard attribute is cleared by shopify:section:load for theme editor support. */
    if (document.documentElement.hasAttribute('data-personalization-initialized')) return;
    document.documentElement.setAttribute('data-personalization-initialized', 'true');

    installArtisanCartBridge();

    var addons = document.querySelectorAll('.artisan-addon[data-block-id]');
    if (!addons.length) return;

    addons.forEach(function(addon) {
      var BLOCK_ID = addon.dataset.blockId;
      var MAX_CHARS = Number(addon.dataset.maxChars) || 8;
      var SERVICE_ID = addon.dataset.serviceVariant ? Number(addon.dataset.serviceVariant) : null;
      var SHOP_MONEY_FORMAT = window.SHOP_MONEY_FORMAT || (window.Shopify && window.Shopify.money_format) || '$ {{amount}}';

      var checkbox = document.getElementById('engraving-check-' + BLOCK_ID);
      var inputWrap = document.getElementById('artisan-input-wrap-' + BLOCK_ID);
      var textInput = document.getElementById('engraving-text-' + BLOCK_ID);
      var countEl = document.getElementById('artisan-count-' + BLOCK_ID);
      var warnEl = document.getElementById('artisan-warn-' + BLOCK_ID);
      var MAX_INIT_ATTEMPTS = 5;
      var RETRY_DELAY = 100;
      var uiBound = false;
      var formBound = false;
      var form = null;

      if (!checkbox || !textInput || !countEl || !warnEl) {
        return;
      }

      // If SERVICE_ID is null, attempt fallback fetch for monogram fees product
      if (!SERVICE_ID) {
        fetch((window.Shopify.routes.root || '/') + 'products/monogrammed-leather-bags-fees.js')
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(p) {
            if (p && p.variants && p.variants.length) {
              SERVICE_ID = p.variants[0].id;
              addon.dataset.serviceVariant = String(SERVICE_ID);
              if (checkbox.checked) {
                syncHiddenFields(sanitizeEngraving(textInput.value).trim());
              }
            }
          })
          .catch(function() {});
      }

      bindUi();
      initialize(0);

      function initialize(attempt) {
        bindForm(attempt || 0);
        ensureCartBridgePatched(attempt || 0);
      }

      function bindUi() {
        if (uiBound) return;
        uiBound = true;

        checkbox.addEventListener('change', function() {
          syncUiStateFromInputs(true);
          if (checkbox.checked) {
            var engravingText = sanitizeEngraving(textInput.value).trim();
            syncHiddenFields(engravingText);
          } else {
            removeHiddenFields();
          }
        });

        textInput.addEventListener('input', function() {
          var sanitizedValue = sanitizeEngraving(textInput.value);
          if (sanitizedValue !== textInput.value) {
            var nextPosition = sanitizedValue.length;
            textInput.value = sanitizedValue;
            textInput.setSelectionRange(nextPosition, nextPosition);
          }

          textInput.setCustomValidity('');
          updateCharacterCount();

          if (checkbox.checked) {
            syncHiddenFields(sanitizedValue);
          }
        });

        textInput.addEventListener('change', function() {
          if (checkbox.checked) {
            syncHiddenFields(sanitizeEngraving(textInput.value).trim());
          }
        });

        syncUiStateFromInputs(false);

        window.addEventListener('pageshow', function() {
          window.setTimeout(function() {
            syncUiStateFromInputs(false);
          }, 0);
        });
      }

      function bindForm(attempt) {
        if (formBound && form && document.body.contains(form)) return;

        var productScope = addon.closest('.product-main') || addon.closest('[data-product-wrapper]') || document;
        form = findRelatedForm(productScope, addon);

        if (!form) {
          if (attempt < MAX_INIT_ATTEMPTS) {
            window.setTimeout(function() {
              bindForm(attempt + 1);
            }, RETRY_DELAY);
          }
          return;
        }

        if (form.dataset.artisanPersonalizationBound === BLOCK_ID) {
          formBound = true;
          return;
        }

        form.dataset.artisanPersonalizationBound = BLOCK_ID;
        formBound = true;

        if (checkbox.checked) {
          syncHiddenFields(sanitizeEngraving(textInput.value).trim());
        }

        form.addEventListener('submit', function(event) {
          if (!checkbox.checked) {
            textInput.setCustomValidity('');
            removeHiddenFields();
            return;
          }

          if (!SERVICE_ID) {
            SERVICE_ID = addon.dataset.serviceVariant ? Number(addon.dataset.serviceVariant) : null;
          }

          var engravingText = sanitizeEngraving(textInput.value).trim();
          textInput.value = engravingText;
          updateCharacterCount();

          if (!engravingText) {
            event.preventDefault();
            addon.classList.add('is-open');
            inputWrap.classList.add('visible');
            textInput.setCustomValidity('Please enter the engraving text.');
            textInput.reportValidity();
            textInput.focus();
            return;
          }

          textInput.setCustomValidity('');
          syncHiddenFields(engravingText);
        }, true);
      }

      function updateCharacterCount() {
        var length = textInput.value.length;
        countEl.textContent = String(length);
        warnEl.style.display = length >= MAX_CHARS ? 'inline' : 'none';
      }

      function syncUiStateFromInputs(shouldFocus) {
        if (checkbox.checked) {
          inputWrap.classList.add('visible');
          addon.classList.add('is-open');
          if (shouldFocus) textInput.focus();
        } else {
          inputWrap.classList.remove('visible');
          textInput.value = '';
          textInput.setCustomValidity('');
          removeHiddenFields();
        }
        updateCharacterCount();
      }

      function sanitizeEngraving(value) {
        return (value || '')
          .toUpperCase()
          .replace(/[^A-Z0-9\s]/g, '')
          .replace(/\s+/g, ' ')
          .replace(/^\s+/, '')
          .slice(0, MAX_CHARS);
      }

      function hiddenInputId(key) {
        return 'artisan-hidden-' + BLOCK_ID + '-' + key;
      }

      function setHiddenField(key, name, value) {
        if (!form) return;
        var hiddenField = form.querySelector('#' + hiddenInputId(key));
        if (!hiddenField) {
          hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.id = hiddenInputId(key);
          hiddenField.setAttribute('data-artisan-hidden', BLOCK_ID);
          form.appendChild(hiddenField);
        }
        hiddenField.name = name;
        hiddenField.value = value;
      }

      function removeHiddenFields() {
        if (!form) return;
        var hiddenFields = form.querySelectorAll('[data-artisan-hidden="' + BLOCK_ID + '"]');
        hiddenFields.forEach(function(field) { field.remove(); });
      }

      function syncHiddenFields(engravingText) {
        var bundleToken = 'artisan-' + BLOCK_ID + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
        removeHiddenFields();
        setHiddenField('text', 'properties[Engraving Text]', engravingText);
        setHiddenField('enabled', 'properties[_Engraving]', 'Yes');
        if (SERVICE_ID) {
          setHiddenField('service-id', '__artisan_service_id', String(SERVICE_ID));
        }
        setHiddenField('service-text', '__artisan_engraving_text', engravingText);
        setHiddenField('bundle', '__artisan_bundle', bundleToken);
      }

      function findRelatedForm(scope, currentAddon) {
        var selectors = [
          'product-form form[action*="/cart"]',
          'form[data-product-form]',
          'form[action*="/cart/add"]'
        ];
        var selector = selectors.join(', ');
        var scopedForms = scope.querySelectorAll(selector);

        if (scopedForms.length >= 1) {
          for (var index = 0; index < scopedForms.length; index += 1) {
            if (!scopedForms[index].closest('[data-product-atc-banner]')) {
              return scopedForms[index];
            }
          }
          return scopedForms[0];
        }

        var formParent = currentAddon.closest('form');
        if (formParent) return formParent;

        var sibling = currentAddon.parentElement;
        while (sibling) {
          if (sibling.querySelector) {
            var siblingForm = sibling.querySelector(selector);
            if (siblingForm) return siblingForm;
          }
          sibling = sibling.nextElementSibling;
        }
        return document.querySelector('form[data-product-form]') || document.querySelector('form[action*="/cart"]');
      }

    }); // end foreach addon
  } // end initPersonalization

  function installArtisanCartBridge() {
    if (!window.__artisanCartBridge) {
      window.__artisanCartBridge = {
        parseEntries: parseEntries,
        addItems: addItems,
        patchAddToCartFlyout: patchAddToCartFlyout
      };
    } else {
      window.__artisanCartBridge.parseEntries = parseEntries;
      window.__artisanCartBridge.addItems = addItems;
      window.__artisanCartBridge.patchAddToCartFlyout = patchAddToCartFlyout;
    }
    bindProductFormCartRequest();
  }

  function ensureCartBridgePatched(attempt) {
    var patched = window.__artisanCartBridge && window.__artisanCartBridge.patchAddToCartFlyout();
    if (!patched && (attempt || 0) < 5) {
      window.setTimeout(function() {
        ensureCartBridgePatched((attempt || 0) + 1);
      }, 100);
    }
  }

  function parseEntries(entries) {
    var mainItem = { quantity: 1, properties: {} };
    var serviceId = null;
    var engravingText = '';
    var bundleToken = '';

    entries.forEach(function(entry) {
      var name = entry.name;
      var value = entry.value;

      if (!name) return;
      if (name === 'id') { mainItem.id = normalizeNumber(value); return; }
      if (name === 'quantity') { mainItem.quantity = normalizeNumber(value) || 1; return; }
      if (name === 'selling_plan' && value !== '') { mainItem.selling_plan = normalizeNumber(value) || value; return; }
      if (name.indexOf('properties[') === 0 && name.charAt(name.length - 1) === ']') {
        mainItem.properties[name.slice(11, -1)] = value;
        return;
      }
      if (name === '__artisan_service_id') { serviceId = normalizeNumber(value); return; }
      if (name === '__artisan_engraving_text') { engravingText = value; return; }
      if (name === '__artisan_bundle') { bundleToken = value; }
    });

    if (!mainItem.id || !serviceId) return null;

    if (bundleToken) {
      mainItem.properties['_Artisan Bundle'] = bundleToken;
      mainItem.properties['_Artisan Role'] = 'main';
    }

    if (!Object.keys(mainItem.properties).length) delete mainItem.properties;

    var serviceItem = {
      id: serviceId,
      quantity: mainItem.quantity || 1,
      properties: { '_Related To': String(mainItem.id) }
    };

    if (engravingText) serviceItem.properties['_Engraving Text'] = engravingText;
    if (bundleToken) {
      serviceItem.properties['_Artisan Bundle'] = bundleToken;
      serviceItem.properties['_Artisan Role'] = 'service';
    }

    return { mainItem: mainItem, serviceItem: serviceItem };
  }

  function normalizeNumber(value) {
    var parsedValue = parseInt(value, 10);
    return isNaN(parsedValue) ? null : parsedValue;
  }

  function addItems(items) {
    return fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function patchAddToCartFlyout() {
    if (!window.AddToCartFlyout || !window.jQuery) return false;
    if (window.AddToCartFlyout.prototype.__artisanPatched) return true;

    var originalUpdateCart = window.AddToCartFlyout.prototype._updateCart;

    window.AddToCartFlyout.prototype._updateCart = function() {
      var parsedRequest = window.__artisanCartBridge.parseEntries(this.formData || []);
      if (!parsedRequest) return originalUpdateCart.call(this);

      var flyOut = this.atcTemplate.cloneNode(true);
      var quantity = parsedRequest.mainItem.quantity || 1;
      var self = this;

      window.__artisanCartBridge.addItems([parsedRequest.mainItem, parsedRequest.serviceItem])
        .then(function(response) {
          var responseItems = response.items || [];
          var primaryItem = null;
          responseItems.forEach(function(item) {
            if (!primaryItem && item.id === parsedRequest.mainItem.id) primaryItem = item;
          });
          if (!primaryItem && responseItems.length > 0) primaryItem = responseItems[0];
          if (!primaryItem) throw new Error('Main product was not returned from cart/add.js.');

          self.itemId = primaryItem.id;
          self.itemKey = primaryItem.key || null;
          self.responseData = primaryItem;
          self.responseData.items = responseItems;

          populateFlyout(flyOut, primaryItem, quantity, self);

          return fetch(window.Theme.routes.cart_url + '.js', {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
        })
        .then(function(response) {
          return response.json().then(function(cart) {
            if (!response.ok) throw cart;
            return cart;
          });
        })
        .then(function(cart) {
          var lineItem = findCartLineItem(cart, self.itemKey, self.itemId);
          if (self.settings.cartRedirection || document.body.classList.contains('template-cart')) {
            window.location.href = window.Theme.routes.cart_url;
            return;
          }

          self.callbacks.onSuccess();
          self.formData = {};
          if (!lineItem) throw new Error('Unable to locate the added product in cart.');

          populateFlyoutTotals(flyOut, lineItem, cart, self);
          mountFlyout(flyOut, cart, self);
        })
        .catch(function(error) {
          self._enableAtcButton();
          self.callbacks.onError(buildErrorMessage(error));
        });
    };

    window.AddToCartFlyout.prototype.__artisanPatched = true;
    return true;
  }

  function populateFlyout(flyOut, lineItem, quantity, flyoutInstance) {
    if (lineItem.image) {
      var imageUrl = flyoutInstance.Images.getSizedImageUrl(lineItem.image, '200x');
      flyoutInstance.Images.loadImage(imageUrl);
      var productImage = flyOut.querySelector('[data-atc-banner-product-image]');
      if (productImage) productImage.innerHTML = '<img src="' + imageUrl + '" alt="' + lineItem.product_title + '">';
    }

    var productTitle = flyOut.querySelector('[data-atc-banner-product-title]');
    if (productTitle) productTitle.textContent = lineItem.product_title;

    if (lineItem.variant_options && lineItem.variant_options[0] !== 'Title' && lineItem.variant_options[0] !== 'Default Title') {
      var productOptions = flyOut.querySelector('[data-atc-banner-product-options]');
      if (productOptions) productOptions.textContent = lineItem.variant_options.join(', ');
    }

    if (lineItem.selling_plan_allocation) {
      var subscriptionTitle = flyOut.querySelector('[data-atc-banner-product-subscription-title]');
      if (subscriptionTitle) subscriptionTitle.textContent = lineItem.selling_plan_allocation.selling_plan.name;
    }

    var productPriceQuantity = flyOut.querySelector('[data-atc-banner-product-price-quantity]');
    if (productPriceQuantity) productPriceQuantity.textContent = quantity + ' × ';
  }

  function populateFlyoutTotals(flyOut, lineItem, cart, flyoutInstance) {
    var productPriceValue = flyOut.querySelector('[data-atc-banner-product-price-value]');
    var productPriceDiscounted = flyOut.querySelector('[data-atc-banner-product-price-discounted]');
    var productDiscounts = flyOut.querySelector('[data-atc-banner-product-discounts]');
    var unitPrice = flyOut.querySelector('[data-atc-banner-unit-price]');
    var subTotal = flyOut.querySelector('[data-atc-banner-cart-subtotal]');
    var itemCount = flyOut.querySelector('[data-atc-banner-cart-button] span');

    if (productPriceValue) productPriceValue.innerHTML = Shopify.formatMoney(lineItem.original_price, flyoutInstance.settings.moneyFormat);
    if (productPriceDiscounted) {
      if (lineItem.final_price < lineItem.original_price) {
        productPriceDiscounted.innerHTML = Shopify.formatMoney(lineItem.final_price, flyoutInstance.settings.moneyFormat);
        productPriceDiscounted.classList.remove('hidden');
        if (productPriceValue) productPriceValue.classList.add('original-price');
      } else {
        productPriceDiscounted.classList.add('hidden');
        if (productPriceValue) productPriceValue.classList.remove('original-price');
      }
    }

    if (productDiscounts) {
      if (lineItem.line_level_discount_allocations && lineItem.line_level_discount_allocations.length > 0) {
        var discountItemTemplate = productDiscounts.firstElementChild ? productDiscounts.firstElementChild.cloneNode(true) : null;
        productDiscounts.innerHTML = '';
        if (discountItemTemplate) {
          lineItem.line_level_discount_allocations.forEach(function(discount) {
            var listItem = discountItemTemplate.cloneNode(true);
            var title = listItem.querySelector('.discount-title');
            var amount = listItem.querySelector('.discount-amount');
            if (title) title.textContent = discount.discount_application.title;
            if (amount) amount.innerHTML = Shopify.formatMoney(discount.amount, flyoutInstance.settings.moneyFormat);
            productDiscounts.appendChild(listItem);
          });
        }
        productDiscounts.classList.remove('hidden');
      } else {
        productDiscounts.classList.add('hidden');
      }
    }

    if (unitPrice) {
      if (lineItem.unit_price_measurement) {
        var unitPriceString = unitPrice.innerHTML;
        unitPriceString = unitPriceString.replace('** total_quantity **', lineItem.unit_price_measurement.quantity_value + '' + lineItem.unit_price_measurement.quantity_unit);
        unitPriceString = unitPriceString.replace('** unit_price **', Shopify.formatMoney(lineItem.unit_price, flyoutInstance.settings.moneyFormat));
        unitPriceString = unitPriceString.replace('** unit_measure **', lineItem.unit_price_measurement.reference_value === 1 ? lineItem.unit_price_measurement.reference_unit : (lineItem.unit_price_measurement.reference_value + '' + lineItem.unit_price_measurement.reference_unit));
        unitPrice.innerHTML = unitPriceString;
        unitPrice.classList.remove('hidden');
      } else {
        unitPrice.classList.add('hidden');
      }
    }

    if (subTotal) subTotal.innerHTML = Shopify.formatMoney(cart.total_price, flyoutInstance.settings.moneyFormat);
    if (itemCount) itemCount.textContent = String(cart.item_count);
  }

  function mountFlyout(flyOut, cart, flyoutInstance) {
    var mountTarget = flyoutInstance.header || document.body;
    mountTarget.appendChild(flyOut);
    flyoutInstance.flyOut = flyOut;
    flyoutInstance.atcAnimation = createAnimationStub(flyOut);

    document.dispatchEvent(new Event('closeFlyouts'));

    var closeButton = flyOut.querySelector('[data-atc-banner-close]');
    if (closeButton) {
      flyoutInstance.events.register(closeButton, 'click', function(event) {
        flyoutInstance._closeFlyOut(event);
      });
    }

    flyoutInstance.events.register(document, 'click', function(event) { flyoutInstance._handleDocumentClick(event); });
    flyoutInstance.events.register(document, 'touchstart', function(event) { flyoutInstance._handleDocumentClick(event); });
    flyoutInstance.events.register(document, 'closeFlyouts', function(event) { flyoutInstance._closeFlyOut(event); });
    flyoutInstance.events.register(window, 'keydown', function(event) { flyoutInstance._closeEsc(event); });

    flyoutInstance._enableAtcButton();
    flyoutInstance.atcAnimation.animateTo('open').then(function() {
      if (window.Shopify && window.Shopify.theme && window.Shopify.theme.a11y && window.Shopify.theme.a11y.trapFocus) {
        window.Shopify.theme.a11y.trapFocus(flyOut);
      }
    });

    window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
  }

  function createAnimationStub(element) {
    return {
      animateTo: function(state) {
        if (state === 'open') element.classList.add('atc-banner--visible');
        else if (state === 'closed') element.classList.remove('atc-banner--visible');
        return Promise.resolve();
      },
      unload: function() {}
    };
  }

  function findCartLineItem(cart, itemKey, itemId) {
    var lineItem = null;
    cart.items.forEach(function(item) {
      var matchesKey = itemKey && item.key === itemKey;
      var matchesId = item.id === itemId;
      if (!matchesKey && !matchesId) return;

      if (!lineItem) { lineItem = item; return; }

      lineItem.line_level_discount_allocations = (lineItem.line_level_discount_allocations || []).concat(item.line_level_discount_allocations || []);
      lineItem.final_price = lineItem.final_price > item.final_price ? lineItem.final_price : item.final_price;
      lineItem.quantity += item.quantity;
    });
    return lineItem;
  }

  function buildErrorMessage(error) {
    if (error && error.description) return error.description;
    if (error && error.message) return error.message;
    if (error && error.status && error.statusText) return error.status + ' ' + error.statusText;
    return 'Unable to add item to cart';
  }

  function bindProductFormCartRequest() {
    if (document.documentElement.hasAttribute('data-artisan-product-form-bridge')) return;
    document.documentElement.setAttribute('data-artisan-product-form-bridge', 'true');

    document.addEventListener('product-form:cart:request', function(event) {
      var formData = event.detail && event.detail.form;
      var formOwner = event.target;
      if (!formData || typeof formData.entries !== 'function') return;

      var entries = [];
      formData.forEach(function(value, name) { entries.push({ name: name, value: value }); });

      var parsedRequest = window.__artisanCartBridge.parseEntries(entries);
      if (!parsedRequest) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (window.AddToCartFlyout && !window.CART_REDIRECTION_ENABLED) {
        var formDataArray = [];
        var submitButton = null;
        formData.forEach(function(value, name) { formDataArray.push({ name: name, value: value }); });

        if (formOwner && formOwner.querySelector) {
          submitButton = formOwner.querySelector('button[type="submit"], input[type="submit"]');
        }

        try {
          var handleComplete = function(completeEvent) {
            document.removeEventListener('addToCartFlyout:complete', handleComplete);
            document.removeEventListener('addToCartFlyout:error', handleError);
            event.detail.resolve(completeEvent.detail.responseData);
          };

          var handleError = function(errorEvent) {
            document.removeEventListener('addToCartFlyout:complete', handleComplete);
            document.removeEventListener('addToCartFlyout:error', handleError);
            event.detail.reject(errorEvent.detail.error);
          };

          document.addEventListener('addToCartFlyout:complete', handleComplete);
          document.addEventListener('addToCartFlyout:error', handleError);

          new window.AddToCartFlyout(formDataArray, {
            atcButton: submitButton || document.createElement('button'),
            settings: {
              moneyFormat: window.SHOP_MONEY_FORMAT || (window.Shopify && window.Shopify.money_format) || '$ {{amount}}',
              cartRedirection: !!window.CART_REDIRECTION_ENABLED
            }
          });
        } catch (error) {
          event.detail.reject(error);
        }
        return;
      }

      window.__artisanCartBridge.addItems([parsedRequest.mainItem, parsedRequest.serviceItem])
        .then(function(response) { event.detail.resolve(response); })
        .catch(function(error) { event.detail.reject(error); });
    }, true);
  }

  function runInit() {
    initPersonalization();
    ensureCartBridgePatched(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
  /* shopify:section:load: clear the init guard first so the theme editor
     can re-initialize personalization after section changes. */
  document.addEventListener('shopify:section:load', function() {
    document.documentElement.removeAttribute('data-personalization-initialized');
    runInit();
  });
})();
